import { Box, CircularProgress } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Person } from '../Models/person';
import { openAlert } from '../Store/AlertSlice';
import { getAllPeople } from '../firebase/Database/GetAllPeople';
import { BoxTitle } from './Text/BoxTitle';

const columns: GridColDef[] = [
    { field: 'firstName', headerName: 'Jméno', flex: 0.2 },
    { field: 'lastName', headerName: 'Příjmení', flex: 0.2 },
    { field: 'email', headerName: 'Email', flex: 0.2 },
];

export const UsersGrid = () => {
    const [rows, setRows] = useState<Person[]>([]);
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        getAllPeople()
            .then((res) => {
                setRows(res);
            })
            .catch((err) => {
                dispatch(
                    openAlert({
                        displayText: 'Nepovedlo se načíst uživatele',
                        severity: 'error',
                    }),
                );
            })
            .finally(() => {
                setLoading(false);
            });
    }, [dispatch]);

    return (
        <Box>
            <BoxTitle>Uživatelé</BoxTitle>
            {loading && <CircularProgress />}
            {!loading && (
                <DataGrid
                    columns={columns}
                    rows={rows}
                    getRowId={(row) => {
                        return row.email;
                    }}
                    initialState={{
                        pagination: { paginationModel: { pageSize: 10 } },
                    }}
                    pageSizeOptions={[10, 25]}
                    style={{ maxWidth: '100%' }}
                    sx={{
                        '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': {
                            display: 'none',
                        },
                    }}
                />
            )}
        </Box>
    );
};
